import React from 'react';
import DatePicker from 'antd/es/date-picker';
import moment from 'moment';
import { EventValue } from 'rc-picker/lib/interface';
import styled from 'styled-components/macro';

const { RangePicker } = DatePicker;

export const DateRangeSelector = ({
  onChange,
  allowEmpty = [true, true],
  placeholderStart = 'Start date',
  placeholderEnd = 'End date',
  defaultStartDate,
  startDate,
  endDate,
  disabled,
  format = 'YYYY-MM-DD',
}: {
  onChange: (dateStrings: [string, string]) => void;
  allowEmpty?: [boolean, boolean];
  placeholderStart?: string;
  placeholderEnd?: string;
  defaultStartDate?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  disabled: [boolean, boolean];
  format?: string;
}) => {
  const handleChange = (
    dates: [EventValue<moment.Moment>, EventValue<moment.Moment>] | null,
    dateStrings: [string, string]
  ) => onChange(dateStrings);
  const startValue = startDate ? moment(startDate, format) : null;
  const endValue = endDate ? moment(endDate, format) : null;
  const startDefaultValue = defaultStartDate
    ? moment(defaultStartDate, format)
    : startValue;
  const endDefaultValue =
    disabled[0] && placeholderStart && !endValue
      ? moment(placeholderStart, format).add(1, 'd')
      : endValue;

  const disabledDate = (current: moment.Moment) => {
    if (!placeholderStart && !disabled[0]) return false;
    return current && current < moment(placeholderStart, format).endOf('day');
  };

  return (
    <StyledRangedPicker>
      <RangePicker
        allowEmpty={allowEmpty}
        placeholder={[placeholderStart, placeholderEnd]}
        disabledDate={disabledDate}
        onChange={handleChange}
        format={format}
        value={[startValue, endDefaultValue]}
        defaultValue={[startDefaultValue, endDefaultValue]}
        disabled={disabled}
        getPopupContainer={(node) => node}
      />
    </StyledRangedPicker>
  );
};

const StyledRangedPicker = styled.div`
  position: relative;
`;
